<div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
    <h1 class="m0 rte-font-size-24 center-text patners-banners-heading">
        {{properties.partnersBanners.bannerHeading}}
    </h1>
    <div>
        <p class="title-xs center-text patners-banners-title">{{properties.partnersBanners.bannerTitle}}</p>

            <ul class="col-md-12 patners-banners-banners-container">
                <li *ngFor="let banner of banners; let i =index"   class="{{'banner'+i}}" aria-checked="false" role="button" [attr.aria-label]="'Go to '+banner + '\'s FreshPass page'" tabindex="0" (click)="goToFreshPass(banner)" (keydown.enter)="goToFreshPass(banner)">
                    <div class="patners-banners-banner-container">
                        <div class="patners-banners-banner-image-container"  tabindex="-1">
                            <img alt="{{banner}} logo" [src]="bannerImages[banner]" class="patners-banners-banner-container-image"/>
                        </div>
                        <div class="patners-banners-banner-navigate-container center-text" tabindex="-1">
                            <span> > </span>
                        </div>
                    </div>
                </li>
            </ul>

    </div>
</div>
